import { SUPPORTED_LOCALES, isSupportedLocale } from '../i18n';
import { useLocale } from '../i18n/LocaleProvider';

/**
 * DE/EN switcher, the same `<select>` recipe as the landing page's header and the portal's.
 *
 * Picking here is what turns a detected language into a persisted one — see
 * `LocaleProvider.setLocale`. The label is visually hidden: the header has no room for it and the
 * options say what they are, but a screen reader still needs it.
 */
export function LanguageSwitcher() {
  const { locale, setLocale, t } = useLocale();

  return (
    <label className="flex items-center">
      <span className="sr-only">{t('language.select')}</span>
      <select
        className="rounded-lg border border-gray-300 bg-white px-2 py-1 text-base sm:text-sm text-gray-700 cursor-pointer hover:border-primary transition-colors focus:outline-none focus:ring-2 focus:ring-primary"
        value={locale}
        onChange={(event) => {
          const next = event.target.value;
          // Guarded rather than cast: the option list is ours, but a value arriving from anywhere
          // else must not become the locale.
          if (isSupportedLocale(next)) {
            setLocale(next);
          }
        }}
      >
        {SUPPORTED_LOCALES.map((value) => (
          <option key={value} value={value}>
            {t(value === 'de' ? 'language.german' : 'language.english')}
          </option>
        ))}
      </select>
    </label>
  );
}
